import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const IceHockey = () => {
  return (
    <SportsLayoutComp name={'Ice Hockey'}/>
  )
}

export default IceHockey